/*
 * File: ZoomInfoLogin.tsx
 * Project: a-a
 * File Created: Thursday, 23rd October 2025 10:05:47 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 23rd October 2025 10:09:37 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { Box, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import CustomButton from '../../../shared/CustomButton/CustomButton';
import zeplinColor from '../../../../theme/Color';

const ZoomInfoLogin = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '32px',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        // backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent background
        zIndex: 100, // Ensure it appears above the blurred content
      }}
    >
      <img src={`/assets/zoominfo-login.svg`} width='48px' height='48px' />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography variant='heading3'>Connect ZoomInfo to Get Started</Typography>
        <Typography variant='body3' sx={{ textAlign: 'center' }} color={zeplinColor.Neutral10}>
          Connect your ZoomInfo account to unlock enriched contact and
          <br />
          company data within Huddle.
        </Typography>
      </Box>
      {process.env.REACT_APP_ZOOMINFO_LOGIN && (
        <Link
          to={process.env.REACT_APP_ZOOMINFO_LOGIN}
          style={{ textDecoration: 'none' }}
          onClick={(e) => {}}
        >
          <CustomButton
            disabled={false}
            onClick={() => {
              //   sessionStorage.setItem('zoominfo-connecting', 'true');
              // sessionStorage.setItem('zoominfo-auth', 'true');
            }}
            variant='contained'
            color={'primary'}
            style={{
              // width: '95px',
              borderRadius: '14px',
              height: 48,
              padding: '14px 16px',
              //  ...(asanaConnecting && { backgroundColor: zeplinColor.Neutral3 }),
              '&.Mui-focusVisible': {
                backgroundColor: '#333CAA',
                //    asanaConnecting ? zeplinColor.Neutral3 : '#333CAA',
              },
            }}
            textStyle={{ color: zeplinColor.Neutral1 }}
            //    asanaConnecting ? zeplinColor.BasicBlack :
            text={'Connect'}
            // icon={<img src={`/assets/add-white.svg`} width={'13.3px'} height={'13.3px'} />}
            // tabindex={4}
          />
        </Link>
      )}
    </Box>
  );
};

export default ZoomInfoLogin;
